/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @module paragraph
 */
export { default as Paragraph } from './paragraph.js';
export { default as ParagraphButtonUI } from './paragraphbuttonui.js';
import './augmentation.js';
